module.exports = require('lodash').uniqWith